import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { PixPaymentFavoredView } from '../models/payment-favored-view.model';
import { Observable } from 'rxjs';
import { PixTransferRequest } from '../models/transfer-request.model';
import { PixReceipt } from '../models/receipt.model';
import { BaseResult } from '../../../shared/models/base.result.model';
import { PixPaymentFavored } from '../models/payment-favored.model';
import { PixTax, PixTransferReturn, TipoTitularidadeTarifa } from '../models/transfer-return.model';

@Injectable()
export class PixPaymentKeyService {
	private url = endpoints.pix;
	private selectedPixPaymentFavoredView: PixPaymentFavoredView;
	private selectedPixPaymentFavoredViewToDelete: PixPaymentFavoredView;
	private selectedPixReceipt: PixReceipt;
	private selectedPixTax?: number;

	constructor(private http: HttpClient) { }

	clearState(): void {
		this.selectedPixPaymentFavoredView = null;
	}

	postTransfer(model: PixTransferRequest): Observable<BaseResult<PixTransferReturn>> {
		return this.http.post<BaseResult<PixTransferReturn>>(`${this.url.transfer}`, model);
	}

	getInfoByCode(code: string): Observable<BaseResult<any>> {
		return this.http.post<BaseResult<any>>(`${this.url.qrcodeAccount}`, { Codigo: code });
	}

	getPixTax(): Observable<BaseResult<PixTax>>{
		return this.http.get<BaseResult<PixTax>>(`${this.url.tax}/MESMA`);
	}

	getSelectedPixPaymentFavoredView = () => this.selectedPixPaymentFavoredView;
	setSelectedPixPaymentFavoredView = (pixPaymentFavoredView: PixPaymentFavoredView) => this.selectedPixPaymentFavoredView = pixPaymentFavoredView;
	getSelectedPixPaymentFavoredViewToDelete = () => this.selectedPixPaymentFavoredViewToDelete;
	setSelectedPixPaymentFavoredViewToDelete = (pixPaymentFavoredView: PixPaymentFavoredView) => this.selectedPixPaymentFavoredViewToDelete = pixPaymentFavoredView;
	getSelectedPixReceipt = () => this.selectedPixReceipt;
	setSelectedPixReceipt = (pixReceipt: PixReceipt) => this.selectedPixReceipt = pixReceipt;
	getSelectedPixTax = () => this.selectedPixTax;
	setSelectedPixTax = (pixTax: number) => this.selectedPixTax = pixTax;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/payment-key.service.ts